import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import ThumbsUpDownIcon from '@mui/icons-material/ThumbsUpDown';
import ModalSliderImage from "../image/ModalSliderImage";


export default function Comment(props) {

    function view() {
        if (props && props.comment) {
            let comment = props.comment;
            return <div className="card shadow fullWidth " style={{height: '100%'}}>
                <div style={{padding: '0.5rem 1rem'}}>
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <p className={"mediumTextBold"}>{comment.customer_name}</p>
                        <p className={"mediumTextBold flex-align-center"} style={{margin: '0'}}>
                            {comment.score && comment.score > 0 ?
                                <span className={"flex-align-center"}><StarIcon
                                    style={{fill: '#f9a825'}}/><p>{comment.score}</p></span> :
                                <span className={"flex-align-center"}>  <StarIcon
                                    style={{fill: 'rgb(247 222 182)'}}/><p>0</p></span>
                            }
                        </p>
                    </div>
                    {comment.suggest_type && comment.suggest_type > 0 ?
                    <div style={{display: "flex", justifyContent: "space-between"}}>
                        <p className={"mediumTextBold flex-align-center"} style={{margin: '0'}}>
                                <span className={"flex-align-center"}>
                                    {comment.suggest_type===1 &&  <ThumbUpAltIcon style={{fill: 'var(--green_3)'}}/> }
                                    {comment.suggest_type===3 &&  <ThumbDownAltIcon style={{fill: 'var(--yellow_1)'}}/> }
                                    {comment.suggest_type===2 &&  <ThumbsUpDownIcon style={{fill: 'var(--green_4)'}}/> }
                                    <p style={{margin:'0.4rem'}}>{comment.suggest_type_text}</p>
                                </span>
                        </p>
                    </div> : <div style={{display: "flex", justifyContent: "space-between"}}>

                        </div>
                    }

                    {comment.comment ?
                        <div style={{display: "flex", justifyContent: "space-between"}}>
                            <p className={"mediumText flex-align-center"} style={{margin: '0',minHeight:'4rem'}}>
                                <span className={"flex-align-center"}>
                                    <p style={{margin:'0.4rem'}} className={props.full===false ? "threeShowLineP" :""}>{comment.comment}</p>
                                </span>
                            </p>
                        </div> : <div style={{display: "flex", justifyContent: "space-between"}}>
                        </div>
                    }
                    {comment.images && comment.images.length>0 ?
                        <ModalSliderImage {...props} images={comment.images}  openImage={props.openImage} /> : <div style={{display: "flex", justifyContent: "space-between"}}>
                        </div>
                    }

                    {props.showDate && props.showDate===true && <div style={{display: "flex", justifyContent: "space-between"}}>
                        {comment.buyer_text!=='' && <p className={"mediumText flatBoxLable"}>{comment.buyer_text}</p> }
                        {comment.buyer_text==='' && <p className={"mediumText "}></p> }
                        <p className={"mediumTextBold flex-align-center"} style={{margin: '0',direction:'ltr'}}>
                            <span className={"flex-align-center"}><p className={"mediumText"}> {comment.date_added}</p></span>
                        </p>
                    </div> }

                </div>

            </div>

        }

    }

    return (<>
        {view()}
    </>)
}